import { on, reducer } from 'ts-action';

import { setCollection, setCollectionProducts, updateCollection, loadingProduct } from './actions';

import { CollectionState } from './';

const initialState: CollectionState = {
    collection: [],
    collectionProducts: {
        data: [],
    },
    loadingProduct: false,
};

export default reducer(
    initialState,
    on(setCollection, (state, { payload }) => ({ ...state, collection: Array.from(new Set(payload)) })),
    on(updateCollection, (state, { payload }) => ({
        ...state,
        collection: Array.from(new Set([...state.collection, payload])),
    })),
    on(setCollectionProducts, (state, { payload }) => ({ ...state, collectionProducts: payload })),
    on(loadingProduct, (state, { payload }) => ({ ...state, loadingProduct: payload }))
);
